import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalService } from './modal.service';
import { QuillModule } from 'ngx-quill';
import {ServiceModule} from '../services/service.module';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {ResizeSearchDirective} from './resize-search.directive';
import { EdlCommonDirectiveModule, EdlCommonModalModule, EdlCommonPipesModule, EdlDatePickerModule, QuillEditorModule, EdlModalUserDirectoryModule, EdlCommonComponentsModule } from '@edl-development/edl-common';
import { ErrorTailorModule } from '@ngneat/error-tailor';
import { ComponentsModule } from '../components/common-components/components.module';
import { ObservationCommentsModule } from '../components/observation-comments/observation-comments.module';
import { EdlModalDatePickerComponent } from './edl-modal-date-picker/edl-modal-date-picker.component';
import { AuthenticateModalComponent } from './authenitcate-modal/authenticate-modal.component';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { SignatureModalComponent } from './signature-modal/signature-modal.component';
import { EdlGenericModalComponent } from './edl-generic-modal/edl-generic-modal.component';
import { EdlSendNotificationModal } from './edl-send-notification-modal/edl-send-notification-modal.component';
import { FileAttachmentModalComponent } from './file-attachment-modal/file-attachment-modal.component';
import { LaddaModule } from 'angular2-ladda';
import { PaetepDuplicateObsModalComponent } from './paetep-duplicate-obs-modal/paetep-duplicate-obs-modal.component';
import { PaetepChangeEvaluatorModalComponent } from './paetep-change-evaluator-modal/paetep-change-evaluator-modal.component';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { QRCodeModule } from 'angularx-qrcode';
import { ContentEditorModalComponent } from './content-editor-modal/content-editor-modal.component';
import { RatingFormAdminConfirmModalComponent } from './rating-form-admin-confirm-modal/rating-form-admin-confirm-modal.component';
import { PaetepDirectiveModule } from '../directives/paetep-directive.module';
import { ReloadApplicationModalComponent } from './reload-app-modal/reload-app-modal.component';

@NgModule({
    imports: [
        CommonModule,
        ComponentsModule,
        EdlCommonModalModule,
        ServiceModule,
        FormsModule,
        ReactiveFormsModule,
        EdlCommonDirectiveModule,
        EdlCommonPipesModule,
        QuillModule,
        QuillEditorModule,
        NgbModule,
        ObservationCommentsModule,
        ErrorTailorModule,
        EdlDatePickerModule,
        TimepickerModule,
        LaddaModule,
        NgxIntlTelInputModule,
        QRCodeModule,
        PaetepDirectiveModule,
        EdlModalUserDirectoryModule,
        EdlCommonComponentsModule
    ],
    providers: [
        ModalService
    ],
    declarations: [
        ResizeSearchDirective,
        EdlModalDatePickerComponent,
        AuthenticateModalComponent,
        SignatureModalComponent,
        EdlGenericModalComponent,
        EdlSendNotificationModal,
        FileAttachmentModalComponent,
        PaetepDuplicateObsModalComponent,
        PaetepChangeEvaluatorModalComponent,
        ContentEditorModalComponent,
        RatingFormAdminConfirmModalComponent,
        ReloadApplicationModalComponent
    ],
    exports: [
        ResizeSearchDirective,
        EdlModalDatePickerComponent,
        AuthenticateModalComponent,
        EdlGenericModalComponent,
        EdlSendNotificationModal
    ]
})
export class ModalModule {}
